import React, { PropsWithChildren, ReactElement, ReactNode } from 'react'

import { Tag } from 'antd'
import classNames from 'classnames'
import noop from 'lodash/noop'

import { IconButton } from 'components/Buttons'
import { Icon } from 'components/core'
import { CHIP_COLORS } from 'const/colors'

import * as styles from './styles.scss'

interface ColoredTagProps {
    color?: string
    onClose: () => void
    className: string
    closable: boolean
    children: ReactNode
}

const ColoredTag = ({
    children,
    color = CHIP_COLORS.BACKGROUND,
    onClose = noop,
    closable = false,
    ...rest
}: PropsWithChildren<ColoredTagProps>): ReactElement => {
    const forwardedProps = {
        color,
        closable,
        ...(rest.className ? { className: rest.className } : {}),
    }

    const handleCloseClick = (e: React.MouseEvent): void => {
        e.stopPropagation()
        onClose()
    }

    return (
        <Tag
            {...forwardedProps}
            rootClassName={classNames({
                [styles['colored-tag']]: closable,
            })}
            closeIcon={
                <IconButton
                    className={styles['remove-button']}
                    size="small"
                    icon={<Icon name="PLUS" rotate={45} size={12} />}
                    onClick={handleCloseClick}
                />
            }
        >
            {children}
        </Tag>
    )
}

export default ColoredTag
